// Light / dark theme toggle. The actual theme state lives in the page root
// (Raffle.jsx) so the whole page can be themed via a data attribute.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { RAFFLE_NS } from './translations';
import { SunIcon, MoonIcon } from './icons';

const ThemeToggle = ({ theme, onToggle }) => {
  const { t } = useTranslation(RAFFLE_NS);
  const isDark = theme === 'dark';
  const label = isDark ? t('theme.toLight') : t('theme.toDark');

  return (
    <button
      type="button"
      className="rf-theme-toggle"
      onClick={onToggle}
      aria-label={label}
      title={label}
    >
      <span className="rf-theme-toggle__icon" aria-hidden="true">
        {isDark ? <MoonIcon size={18} /> : <SunIcon size={18} />}
      </span>
    </button>
  );
};

export default ThemeToggle;
